import { EditValuesProvider } from "../../contexts/EditValuesContext";
import { SubSection } from "../../pages/PaddocksMap/ShowData/SubSection";
import { CreateProfiles } from "../../pages/Onboarding/Register/CreateProfiles/Index";

export function ViewInfo() {

    return (
        <EditValuesProvider>
            <SubSection items={[{ element: <CreateProfiles onlyRead={true} /> }]} defaultValue={0} />
        </EditValuesProvider>
    );
}
